import ShareableLinkMobileNavigation from './ShareableLinkMobileNavigation.component';

export default ShareableLinkMobileNavigation;